import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/lib/api';

export function usePublishedContent(endpoint, initialData = null) {
  const [state, setState] = useState({ data: initialData, error: false, notFound: false });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setState({ data: initialData, error: false, notFound: false });
    axios.get(`${API}/${endpoint}`, { timeout: 15000 }).then(({ data }) => {
      if (active) setState({ data, error: false });
    }).catch(error => {
      if (active) setState({ data: null, error: true, notFound: error.response?.status === 404 });
    });
    return () => { active = false; };
  }, [endpoint, attempt, initialData]);
  return { ...state, retry: () => setAttempt(a => a + 1) };
}

